import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import useFetch from 'CustomHooks/useFetch';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import {capitalizeFirstLetter} from '../../Util/StringFunctions';

export default function CurrencySelector (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const [putCustomerSettingsHookResponse, putCustomerSettingsHook] = useFetch();
    const [getCustomerSettingsHookResponse, getCustomerSettingsHook] = useFetch();
    const [currency, setCurrency] = useState('');
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
    
          getCustomerSettingsHook(
            {
              url: '/admin/customersettings',
              addTokenHeader: true,
              method: 'GET',
              postData: null,
            }
          )
          
        }, []
      )
    
      useEffect(
        () => {
          console.log(getCustomerSettingsHookResponse);
          if (getCustomerSettingsHookResponse.length != 0 && getCustomerSettingsHookResponse) {
            setCurrency(getCustomerSettingsHookResponse.currency)
          }
    
        }, [getCustomerSettingsHookResponse]
      )
    
    
      const handleSelectChange = (e) => {
        setCurrency(e.target.value);
        putCustomerSettings('', e.target.value);
      }
    
      const putCustomerSettings = (logoFileBase64, _currency, _fileName) => {
    
        console.log(_fileName);
        if (_currency == '') {
          _currency = currency;
        }
    
        putCustomerSettingsHook(
          {
            url: '/admin/customersettings',
            addTokenHeader: true,
            method: 'PUT',
            postData: {
              currency: _currency,
            },
          }
        )
      }
    
  

    return (
        <Paper elevation={3} style={{ padding: '10px', marginBottom: '30px' }}>

        <div>
            {capitalizeFirstLetter(translateGui(110))}: <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={currency}
            onChange={handleSelectChange}
            className={classes.currencyCombo}
          >
            <MenuItem value={'gbp'}>GBP</MenuItem>
            <MenuItem value={'usd'}>USD</MenuItem>
            <MenuItem value={'eur'}>EUR</MenuItem>
            <MenuItem value={'chf'}>CHF</MenuItem>
            <MenuItem value={'tl'}>TL</MenuItem>
          </Select>
        </div>
      </Paper>
      
    )
}

const useStyles = makeStyles({
    root: {
    },
    currencyCombo: {
        marginLeft: '10px',
    },
});